export enum GetCoordinationByIdResultType {
    Unknown = 'An unknown error has occurred while fetching the DataMiner System.',
    UnauthorizedUserClaim = `You are unauthorized to fetch this DataMiner System because you don't have the required claim.`,
    UnauthorizedUser = 'You are unauthorized for this DataMiner System.',
    DmsNotFound = 'The DataMiner System could not be found.',
    OrganizationNotFound = 'The Organization could not be found.',
    Timeout = 'The DataMiner System could not be loaded because the request took too long.'
}
